export const GROUPS = {
  ADMIN: 'mc-admin',
  MANAGER: 'mc-manager',
  INSPECTOR: 'mc-inspector',
  LOGISTICS: 'mc-logistics',
};
